import { __decorate } from "tslib";
import Component from "vue-class-component";
import ReactiveComponent from "../components/ReactiveComponent";
import Task from "@/services/task";
import TemplateContent from "@/components/template/TemplateContent.vue";
import UserForm from "@/components/UserForm.vue";
import { Prop } from "vue-property-decorator";
let EditUser = class EditUser extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.email = "";
        this.firstname = "";
        this.lastname = "";
        this.role = "";
        this.boards = Array();
        this.optionExtraStrength = false;
        this.optionExtraGym = false;
        this.optionExtraAerobic = false;
        this.optionExtraDouble = false;
        this.userQuery = { user: [] };
        this.userTask = Task.idle();
        this.submitTask = Task.idle();
    }
    created() {
        const idNumber = Number(this.id);
        if (idNumber == null || Number.isNaN(idNumber)) {
            console.log("Invalid id prop");
            return;
        }
        this.subscribeQuery({
            tag: "user",
            options: {
                query: require("@/apollo/queries/userById.graphql"),
                variables: { id: idNumber },
            },
            onTask: (task) => {
                this.userTask = task;
                if (task.isSuccessful) {
                    this.userQuery = task.data;
                    this.firstname = this.userQuery.user[0].firstname;
                    this.lastname = this.userQuery.user[0].lastname;
                    this.email = this.userQuery.user[0].email;
                    this.role = this.userQuery.user[0].role;
                    this.optionExtraStrength = this.userQuery.user[0].option_extra_strength;
                    this.optionExtraGym = this.userQuery.user[0].option_extra_gym;
                    this.optionExtraAerobic = this.userQuery.user[0].option_extra_aerobic;
                    this.optionExtraDouble = this.userQuery.user[0].option_extra_double;
                    this.boards = this.userQuery.user[0].users_boards.map((it) => it.board.id);
                }
            },
        });
    }
    submit() {
        const allUsersQuery = require("@/apollo/queries/allUsers.graphql");
        this.subscribeMutation({
            tag: "submit",
            options: {
                mutation: require("@/apollo/mutations/updateUser.graphql"),
                variables: {
                    id: this.userQuery.user[0].id,
                    firstname: this.firstname,
                    lastname: this.lastname,
                    email: this.email.trim().toLowerCase(),
                    role: this.role,
                    optionExtraStrength: this.optionExtraStrength,
                    optionExtraGym: this.optionExtraGym,
                    optionExtraAerobic: this.optionExtraAerobic,
                    optionExtraDouble: this.optionExtraDouble,
                    boards: this.boards.map((it) => ({
                        board_id: it,
                        user_id: this.userQuery.user[0].id,
                    })),
                },
                update: (store, { data }) => {
                    try {
                        const allUsers = store.readQuery({
                            query: allUsersQuery,
                        });
                        const user = data.update_user.returning[0];
                        const index = allUsers.user.findIndex((it) => it.id == user.id);
                        if (index >= 0) {
                            allUsers.user[index] = user;
                        }
                        else {
                            allUsers.user.push(user);
                        }
                        store.writeQuery({ query: allUsersQuery, data: allUsers });
                    }
                    catch (e) {
                        console.log("Failed to update cache after update_user mutation");
                    }
                },
            },
            onTask: (task) => {
                this.submitTask = task;
                if (task.isSuccessful) {
                    this.$router.push({ name: "users" });
                }
            },
        });
    }
};
__decorate([
    Prop([String, Number])
], EditUser.prototype, "id", void 0);
EditUser = __decorate([
    Component({
        components: { UserForm, TemplateContent },
    })
], EditUser);
export default EditUser;
